
import { StylishSelector } from '@/components/checkboxes/StylishSelector';
import { Camera, PenTool, Origami, Box } from 'lucide-react';

const styleOptions = [
  { id: 'style-photo', name: 'Photo', icon: Camera },
  { id: 'style-art', name: 'Art', icon: PenTool },
  { id: 'style-anime', name: 'Anime', icon: Origami },
  { id: 'style-3d', name: '3D', icon: Box }
];

export interface CoverImageStyleSelectorProps {
  selectedStyle: string;
  onSelectStyle: (style: string) => void;
}

export const CoverImageStyleSelector: React.FC<CoverImageStyleSelectorProps> = ({ 
  selectedStyle, 
  onSelectStyle 
}) => {
  return (
    <div>
      <div className="mb-3">
        <h3 className="text-sm font-medium mb-1 text-purple-600 dark:text-purple-400">Image Type</h3>
      </div>
      <StylishSelector
        styles={styleOptions}
        selectedStyle={selectedStyle}
        onSelectStyle={onSelectStyle}
        className="grid-cols-2 gap-4"
        colorVariant="purple"
        checkColor="purple-500"
      />
    </div>
  );
};

export default CoverImageStyleSelector;
